import { render } from "./DeleteRoleModal.vue?vue&type=template&id=3a5acbc0&scoped=true&ts=true"
import script from "./DeleteRoleModal.vue?vue&type=script&lang=ts"
export * from "./DeleteRoleModal.vue?vue&type=script&lang=ts"

import "./DeleteRoleModal.vue?vue&type=style&index=0&id=3a5acbc0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5acbc0"]])

export default __exports__